import type { HTMLAttributes } from 'react';
import { useCatalogGesture } from './catalogLink';

/** A table row that Ctrl+klik (Mac; Windows: Alt+klik) opens in the catalog (`open`; absent: an ordinary row). */
export function CatalogRow({ open, ...rest }: HTMLAttributes<HTMLTableRowElement> & { open: (() => void) | undefined }) {
  const catalog = useCatalogGesture(open);
  return <tr {...rest} onClick={open ? (e) => void catalog.onClick(e) : undefined} onContextMenu={open ? (e) => void catalog.onContextMenu(e) : undefined} />;
}
